// external libs
import { Grid } from '@material-ui/core'
import { Form } from 'react-final-form'

// components
import Autocomplete from '../../../../../control/autocomplete/autocomplete'
import Button from '../../../../../control/button/button'
import Dialog from '../../../../../control/dialog/dialog'

// hooks
import useRequestConsiderDoc from './useRequestConsiderDoc'
import useTranslate from '../../../../../i18n/useTranslate'

// types
import { TOptions } from '../../../../../control/autocomplete/autocompleteType'

type SentDocOtherViewProps = {
    option: Array<Pick<TOptions, 'value' | 'label' | 'description'>>
    onClickSave: (val: any) => void
    onClickClose: (val: any) => void
}

const SentDocOtherView = (props: SentDocOtherViewProps) => {
    const { option, onClickSave, onClickClose } = props
    const translate = useTranslate()

    return (
        <Form onSubmit={onClickSave} initialValues={{}} keepDirtyOnReinitialize={true}>
            {(props) => {
                const { handleSubmit } = props
                return (
                    <>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <Autocomplete
                                    name="projectSubmitType"
                                    materialInputProps={{
                                        label: translate.get('LABEL.SUBMITTED_PROJECT_TYPE'),
                                        placeholder: translate.get('LABEL.SUBMITTED_PROJECT_TYPE'),
                                    }}
                                    options={option}
                                    required
                                />
                            </Grid>
                            <Grid item xs={3} md={3} lg={3}>
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={onClickClose}
                                    style={{ backgroundColor: '#FFFFFF', border: 'solid 1px #db5f8e' }}
                                >
                                    {translate.get('BUTTON.CANCEL')}
                                </Button>
                            </Grid>
                            <Grid item xs={6} md={6} lg={6}>
                                <Button variant="contained" color="primary" onClick={handleSubmit}>
                                    {translate.get('BUTTON.SAVE')}
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                )
            }}
        </Form>
    )
}

export type RequestConsiderDocViewType = {
    onRefDialog: (fn: Record<string, Function>) => void
    lstOption: any
    onClickClose: () => void
    onClickSave: (projectInfo: any) => void
}
const RequestConsiderDocView = (props: RequestConsiderDocViewType) => {
    const { lstOption, onRefDialog, onClickClose, onClickSave } = props
    const translate = useTranslate()

    const formatLookup: SentDocOtherViewProps['option'] = lstOption.map((itm: any) => {
        return { value: itm.value, label: itm.label, description: itm.description }
    })

    return (
        <Dialog
            onRef={onRefDialog}
            title={translate.get('LABEL.SUBMIT_ADD_PROJECT')}
            type=""
            content={<SentDocOtherView option={formatLookup} onClickClose={onClickClose} onClickSave={onClickSave} />}
        />
    )
}

export type RequestConsiderDocType = {
    bindRef: React.MutableRefObject<any>
}
const RequestConsiderDoc = (props: RequestConsiderDocType) => {
    const sentDocConsider = useRequestConsiderDoc(props)
    return (
        <RequestConsiderDocView
            lstOption={sentDocConsider.lstOption}
            onRefDialog={sentDocConsider.onRefDialog}
            onClickClose={sentDocConsider.onClickClose}
            onClickSave={sentDocConsider.onClickSave}
        />
    )
}

export default RequestConsiderDoc
